define('settings/lib/audio/audio',['require','lodash','knockout','durandal/app','i18next','react-settings-panes','api-access','api-access','lib/audio/check-error','lib/audio/construct-local-audio','lib/audio/construct-api-audio','knockout-bind-react'],function (require) {
    var _ = require('lodash');
    var ko = require('knockout');
    var app = require('durandal/app');
    var i18n = require('i18next');
    var AudioPane = require('react-settings-panes').AudioPane;
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var checkError = require('lib/audio/check-error');
    var constructLocalAudio = require('lib/audio/construct-local-audio');
    var constructApiAudio = require('lib/audio/construct-api-audio');

    require('knockout-bind-react');

    return function () {
        var self = this;

        self.activate = function () {
            self.userSettings = ko.observable({});

            self.audio = ko.observable();
            self.originalAudio = ko.observable();

            self.isAudioError = ko.pureComputed(function () {
                return _.some(_.values(checkError(self.audio())));
            });

            var handleChange = function (field, value) {
                var audio = _.cloneDeep(self.audio());
                audio[field] = value;

                self.audio(audio);
            };

            self.reactOptions = ko.pureComputed(function () {
                var userSettings = self.userSettings();
                var audioSettings = self.audio();
                var allowedModes = _.get(userSettings, 'audio.allowedModes', []);
                var statusCode = userSettings.audio.responseStatusCode;
                var disableEdit = !(statusCode >= 200 && statusCode < 300);
                var model = _.assign({userSettings: userSettings}, audioSettings);

                if (userSettings.isDialOutEnabled && userSettings.isDialOutProvisioned &&
                  allowedModes.indexOf('DIALOUT') === -1) {
                    userSettings.audio.allowedModes.push('DIALOUT');
                }

                if (disableEdit) {
                    model.tollCountries = [];
                }

                return {
                    component: AudioPane,
                    props: {
                        handleChange: handleChange,
                        isPreferredActive: true,
                        locale: i18n.lng(),
                        disableEdit: disableEdit,
                        model: model
                    }
                };
            });

            self.save = function () {
                var localAudio = self.reactOptions().props.model;
                var allowedModes = self.userSettings().audio.allowedModes;

                userApi.updateSettings(constructApiAudio(localAudio, allowedModes))
                    .then(function () {
                        app.trigger('settings:save');
                        self.originalAudio(_.cloneDeep(self.audio()));
                    })
                    .fail(function () {
                        self.audio(_.cloneDeep(self.originalAudio()));
                    });
            };

            self.cancel = function () {
                self.audio(_.cloneDeep(self.originalAudio()));
            };

            self.showButtons = ko.computed(function () {
                return !_.isEqual(self.audio(), self.originalAudio());
            });

            var constructAudio = function (userSettings) {
                var completion = $.Deferred();
                var billingCountry;

                commerceApi.getBilling()
                    .then(function (billing) {
                        billingCountry = billing.country;
                    })
                    .always(function () {
                        var otherSettings = {
                            billingCountry: billingCountry,
                            isDialOutInternationalEnabled: userSettings.isDialOutInternationalEnabled ?
                              userSettings.isDialOutInternationalEnabled : false
                        };

                        var localAudioSettings = constructLocalAudio(userSettings.audio, otherSettings);
                        self.audio(localAudioSettings);
                        self.originalAudio(localAudioSettings);
                        completion.resolve();
                    });

                return completion.promise();
            };

            return $.when(userApi.settings(), userApi.me()).then(function (userSettingsResponse) {
                var userSettings = userSettingsResponse[0];

                // Store userSettings audio server status code
                userSettings.audio.responseStatusCode = userSettings.serviceStatus.audioService.statusCode;

                self.userSettings(userSettings);

                return constructAudio(userSettings);
            });
        };
    };
});

